import React, { Component } from 'react';
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import { signProject, discardProject } from '../../store/actions/projectActions'
import { Redirect } from 'react-router-dom'
import moment from 'moment';
import { NavLink } from 'react-router-dom';
import { Document, Page } from 'react-pdf';
import SignModal from './CreateModal';
import M from 'materialize-css';

import WholePagePDFPreview from './WholePagePDFPreview'
import DetailPreview from './DetailPreview';
import VerifyEmail from '../layout/VerifyEmail';
M.AutoInit();


class ProjectDetails extends Component {

  state = {
    withCompany2: false,
    sign2: false,
    esign2: this.props.profile.esign,
    signedAt: new Date(),
    privateAddress2: this.props.profile.privateAddress,
    companyName2: this.props.profile.companyName,
    companyTitle2: this.props.profile.companyTitle,
    companyAddress2: this.props.profile.companyAddress,
    docType: null,
    password: null,
    numPages: null,
    isModalShown: false
  }

  onDocumentLoadSuccess = ({ numPages }) => {
    this.setState({ numPages });
  }


  handleChange = (e) => {
    if (e.target.id === "sign2" || e.target.id === "withCompany2") {
      this.setState({
        [e.target.id]: e.target.checked
      })
    } else {
      this.setState({
        [e.target.id]: e.target.value
      })
    }
  }

  exportPDF = () => {
    this.resume.save();
  }

  handleClick = (withCompany2, password, project, profile) => e => {
    e.preventDefault();
    this.setState({ sign2: true })
    const projectId = window.location.pathname.split("/")[2]
    let promise = Promise.resolve();
    promise
      .then(
        this.props.signProject(projectId, withCompany2, password)
      )
      .then(this.setState({ isModalShown: true }))
    // .then(
    //   M.toast({ html: 'NDA signed successfully!', classes: 'rounded' })
    // )
    // .then(this.props.history.push('/dashboard'))

  }


  handleDownload = (hash, title) => e => {
    e.preventDefault();
    const FileSaver = require('file-saver');
    FileSaver.saveAs(`https://ipfs.io/ipfs/${hash}`, `nda_${title}.pdf`);
    // TODO can this be seen?
  }
  yoerror = (error) => {
    console.log('Error while loading document! ' + error.message)
  }



  onDiscard = (e) => {
    const projectId = window.location.pathname.split("/")[2]
    this.props.discardProject(projectId)
    M.toast({ html: 'NDA discarded successfully!', classes: 'rounded' })
    this.props.history.push('/dashboard');
  }



  render() {
    const { project, auth, profile } = this.props



    if (!auth.uid) return <Redirect to={'/signin'} />
    if (auth.emailVerified) {
      if (project) {
        const status = (project.sign2 === true && project.finalized) ? <div className="teal-text">Status: Signed </div> : <div className="pink-text">Status: Waiting to be signed </div>
        const isFinalized = project.finalized
        // const isCreated = !!project.createdAt
        const isCompanyRegistered = !!profile.companyName
        const isTitleRegistered = !!profile.companyTitle
        const discardbutton = (!isFinalized) ? <button className="btn white pink-text lighten-4 z-depth-1" onClick={this.onDiscard}>Discard</button> : null
        const dlink = (project.finalized && project.hash) ? <div className='btn teal waves-effect waves-light lighten-1' onClick={this.handleDownload(project.hash, project.title)}>Download from decentralized storage</div> : null
        const wholepdfpreview = project.docType === "uploaded" ? <WholePagePDFPreview filename={project.filename} /> : null


        let confirmbutton;
        if (project.docType === "template1") {
          if (this.state.sign2 === true && !!this.state.password) {
            confirmbutton = (<div className='btn teal waves-effect waves-light lighten-1' onClick={this.handleClick(this.state.withCompany2, this.state.password, project, profile)}>Confirm</div>)
          } else {
            confirmbutton = (<div className='btn teal waves-effect waves-light lighten-1 disabled'>Confirm</div>)
          }
        } else if (project.docType === "uploaded") {
          if (this.state.sign2 === true && !!this.state.password) {
            confirmbutton = (<div className='btn teal waves-effect waves-light lighten-1' onClick={this.handleClick(this.state.withCompany2, this.state.password, project, profile)}>Confirm</div>)
          } else {
            confirmbutton = (<div className='btn teal waves-effect waves-light lighten-1 disabled'>Confirm</div>)
          }
        }

        let buttons;
        if (project.docType === "template1") {
          if (isCompanyRegistered && isTitleRegistered && !isFinalized && (profile.email === project.email2)) {
            buttons = (
              <div>
                <div className="input-field">
                  <p>
                    <label htmlFor="withCompany2">
                      <input type="checkbox" id="withCompany2" onChange={this.handleChange} />
                      <span>Include your company and title ({profile.companyTitle}, {profile.companyName})</span>
                    </label>
                  </p>
                </div>
              </div>
            )
          } else if ((!isCompanyRegistered || !isTitleRegistered) && (!isFinalized) && (profile.email === project.email2)) {
            buttons = (
              <div className="input-field">
                <p>
                  <label htmlFor="withCompany2">
                    <input disabled type="checkbox" id="withCompany2" onChange={this.handleChange} />
                    <span>Include your company and title (<NavLink className="teal-text" to='/profile'>From here</NavLink> you can register) </span>

                  </label>
                </p>
              </div>
            )
          }
        }


        let signbutton;
        if (!isFinalized && (profile.email === project.email2)) {
          signbutton = (
            <div>

              <div className="input-field">
                <p>
                  <label htmlFor="sign2">
                    <input type="checkbox" id="sign2" onChange={this.handleChange} />
                    <span>Sign</span>
                  </label>
                </p>
              </div>

              <div className="input-field col s12">
                <p>
                  <label htmlFor="password">
                    <input id="password" type="password" className="validate" onChange={this.handleChange} />
                    <span>Set password for this NDA (We discard this after pdf is created)</span>
                  </label>
                </p>
              </div>

              <div className="row">
                <div className="col a3 m3">
                  {confirmbutton}
                </div>
                <div className="col a3 m3">
                  {discardbutton}
                </div>
              </div>
            </div>
          )
        }

        return (
          <div className="container section project-details" id="themain">
            <div className="card">
              <div className="card-content">
                <span className="card-title">{project.title}</span>
                <div className="divider"></div>

                {wholepdfpreview}
                <DetailPreview project={project} profile={profile} state={this.state} />


              </div>
              <div className="card-action grey lighten-4 grey-text">
                <div>Created by {project.authorFirstName} {project.authorLastName}</div>
                <div>Sent to {project.email2}</div>

                <div>{moment(project.createdAt.toDate()).calendar()}</div>
                {status}
                {buttons}
                {signbutton}
                {dlink}

              </div>
            </div >

            {this.state.isModalShown &&
              <SignModal onClose={() => {
                this.setState({
                  isModalShown: false
                })
                this.props.history.push('/dashboard')
              }} />
            }

          </div >

        )
      } else {
        return (
          <div className="container center">
            <p> Loading information...</p>
          </div>
        )
      }

    } else if (auth && !auth.emailVerified) {
      return (
        <VerifyEmail auth={auth} />
      )
    }
  }
}


const mapStateToProps = (state, ownProps) => {
  const id = ownProps.match.params.id
  const projects = state.firestore.data.projects;
  const project = projects ? projects[id] : null


  return {
    project: project,
    auth: state.firebase.auth,
    profile: state.firebase.profile
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    signProject: (projectId, withCompany2, password) => dispatch(signProject(projectId, withCompany2, password)),
    discardProject: (projectId) => dispatch(discardProject(projectId))
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  firestoreConnect([
    { collection: 'projects' }
  ])
)(ProjectDetails);